module.exports = __webpack_public_path__ + "8054530f08effda9eb639b9cb88484d5.mp4";